import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/** 未登录,出了直接渲染路由外,在路由上层显示登录引导遮罩 */
function addLoginGuideMiddleware(path, children = []) {
    return {
        path,
        component: () => import('@/middleware/multi-platform-auth/login-guide.vue'),
        children: Array.isArray(children) ? children : [children],
    }
}

/** mock登录数据 */
function addLoginMockMiddleware(path, children = []) {
    return {
        path,
        component: () => import('@/middleware/login-mock/index.vue'),
        children: Array.isArray(children) ? children : [children],
    }
}

/**
 *
 * 不强制登录
 * 1. 微信环境中,初次打开将会尝试直接登录
 * 2. 普通浏览器内,直接渲染路由
 * 3. 开吧app内如果登录成功会重新加载页面,否则直接加载页面
 */
function addMultiPlatformQuiteAuthMiddleware(path, children = []) {
    return {
        path,
        component: () => import('@/middleware/multi-platform-auth/quiet.vue'),
        children: Array.isArray(children) ? children : [children],
    }
}

/** 只有登录完成后,才会显示该中间件下的路由 */
function addMultiPlatformForceAuthMiddleware(path, children = []) {
    return {
        path,
        component: () => import('@/middleware/multi-platform-auth/force.vue'),
        children: Array.isArray(children) ? children : [children],
    }
}

/** 根据路径刷新router-view */
function addRefreshFullpathMiddleware(path, children = []) {
    return {
        path,
        component: () => import('@/middleware/refresh-fullpath/index.vue'),
        children: Array.isArray(children) ? children : [children],
    }
}

/** 只能在开吧app内打开 */
function addOnlyInKbappMiddleware(path, children = []) {
    return {
        path,
        component: () => import('@/middleware/only-in-kbapp/index.vue'),
        children: Array.isArray(children) ? children : [children],
    }
}

/**
 *
 * @description 花名册限制中间件
 * @param {{ path: string; instanceKey: string; coverImage?: string }} params
 * @param {any[]} children
 **/
function addOnlyInUserRosterMiddleware(params, children = []) {
    return {
        path: params.path,
        props: {
            instanceKey: params.instanceKey,
            coverImage: params.coverImage,
        },
        component: () => import('@/middleware/only-in-user-roster/index.vue'),
        children: Array.isArray(children) ? children : [children],
    }
}

/** nddyny专用 */
function addNddynyV1Middleware(path, children = []) {
    return {
        path,
        component: () => import('@/middleware/nddynyV1/indexNddynyV1Middleware.vue'),
        children: Array.isArray(children) ? children : [children],
    }
}

/** nddyny专用 */
function addNddynyV2Middleware(path, children = []) {
    return {
        path,
        component: () => import('@/middleware/nddynyV2/indexNddynyV2Middleware.vue'),
        children: Array.isArray(children) ? children : [children],
    }
}

const routes = [
    { path: '*', name: '404', redirect: '/404' },
    {
        path: '/',
        name: 'default',
        component: () => import('@/views/appDownload/index'),
    },
    {
        path: '/404',
        component: () => import('@/views/404'),
    },
    {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index'),
    },
    addNddynyV2Middleware(
        '/temp/notIllegalClock5',
        [
            {
                path: '/',
                props: true,
                component: () => import('@/views/temp/notIllegalClock5/index'),
            },
            {
                path: 'question',
                props: (route) => ({ ...route.query }),
                component: () => import('@/views/temp/notIllegalClock5/question'),
            },
            {
                path: 'invite',
                props: true,
                component: () => import('@/views/temp/notIllegalClock5/invite'),
            },
            {
                path: 'newArticle/:articleId',
                props: true,
                component: () => import('@/views/temp/notIllegalClock5/newArticle'),
            },
        ],
    ),
    addMultiPlatformQuiteAuthMiddleware(
        '/temp/shaoerchunwan2024',
        addNddynyV2Middleware('/', [
            {
                path: '/',
                props: true,
                component: () => import('@/views/temp/shaoerchunwan/2024/list'),
            },
            {
                path: 'info',
                props: true,
                component: () => import('@/views/temp/shaoerchunwan/2024/info'),
            },
        ]),
    ),
    addNddynyV2Middleware(
        '/',
        addMultiPlatformForceAuthMiddleware('/temp/hcrtHappy202312', [
            {
                path: '/',
                props: true,
                component: () => import('@/views/temp/hcrtHappy202312/index'),
            },
            {
                path: 'exchange',
                props: true,
                component: () => import('@/views/temp/hcrtHappy202312/exchange'),
            },
            {
                path: 'rank',
                props: true,
                component: () => import('@/views/temp/hcrtHappy202312/rank'),
            },
            {
                path: 'invite',
                props: true,
                component: () => import('@/views/temp/hcrtHappy202312/invite'),
            },
            {
                path: 'feedback',
                props: true,
                component: () => import('@/views/temp/hcrtHappy202312/feedback'),
            },
        ]),
    ),
    addMultiPlatformQuiteAuthMiddleware(
        '/',
        addNddynyV2Middleware('/temp/meideshaonian2024', [
            {
                path: 'list',
                props: true,
                component: () => import('@/views/temp/meideshaonian/meideshaonian2024/list'),
            },
        ]),
    ),
    addMultiPlatformQuiteAuthMiddleware(
        '/',
        addNddynyV2Middleware('/temp/penguinNaming202312', [
            {
                path: '/',
                props: true,
                component: () => import('@/views/temp/penguinNaming202312/index'),
            },
            {
                path: 'clock',
                props: true,
                component: () => import('@/views/temp/penguinNaming202312/clock'),
            },
            {
                path: 'activity2024-1',
                props: true,
                component: () => import('@/views/temp/penguinNaming202312/activity2024-1'),
            },
        ]),
    ),
    addMultiPlatformQuiteAuthMiddleware(
        '/shortPlay/work',
        addNddynyV1Middleware('/', [
            {
                path: 'list/:theatreKey',
                props: true,
                component: () => import('@/views/shortPlay/work/listWorkShortPlay'),
            },
            {
                path: 'info',
                component: () => import('@/views/shortPlay/work/infoWorkShortPlay'),
            },
        ]),
    ),
    addMultiPlatformQuiteAuthMiddleware(
        '/temp/xingzbVote202309',
        addNddynyV1Middleware('/', [
            {
                path: 'voteList',
                component: () => import('@/views/temp/xingzbVote202309/voteList.vue'),
            },
        ]),
    ),
    {
        path: '/test',
        name: 'test',
        component: () => import('@/views/test/test'),
    },
    {
        path: '/test1',
        name: 'test1',
        component: () => import('@/views/test/test1'),
    },
    {
        path: '/test2',
        name: 'test2',
        component: () => import('@/views/test/test2'),
    },
    {
        path: '/test/alipay',
        name: 'testAlipay',
        component: () => import('@/views/test/alipay'),
    },
    {
        path: '/test/login',
        name: 'testLogin',
        component: () => import('@/views/test/login'),
    },
    {
        path: '/app/about',
        name: 'AppAbout',
        component: () => import('@/views/about/about'),
    },
    {
        path: '/note',
        name: 'note',
        component: () => import('@/views/note/index'),
    },
    {
        path: '/note/index',
        name: 'noteIndex',
        component: () => import('@/views/note/index'),
    },
    {
        path: '/note/list',
        name: 'noteList',
        component: () => import('@/views/note/index'),
    },
    {
        path: '/note/detail',
        name: 'noteDetail',
        component: () => import('@/views/note/detail'),
        meta: { title: '详情' },
    },
    {
        path: '/startapp',
        name: 'noteDetail',
        component: () => import('@/views/startapp/index'),
        meta: { title: '详情' },
    },
    addRefreshFullpathMiddleware('/', {
        path: '/news/index',
        name: 'news',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/news/detail/data-loader.vue'),
    }),
    {
        path: '/news/advert',
        name: 'newsAdvert',
        component: () => import('@/views/news/advert'),
    },
    {
        path: '/news/indexForSure',
        name: 'newsForSure',
        redirect: (to) => {
            // 暂时先采用重定向方式,到时候重写优化
            return { path: '/news/index', query: { id: to.query.id, is_preview: '1' } }
        },
    },
    addLoginMockMiddleware('/', {
        path: '/hottopic/index',
        name: 'hottopic',
        props: (to) => ({
            id: to.query.id,
        }),
        component: () => import(/* webpackChunkName: "hottopic" */ '@/views/hotTopic/detail/index-loader.vue'),
    }),
    {
        path: '/hottopic/list',
        name: 'hottopicList',
        component: () => import('@/views/hotTopic/list/index.vue'),
    },
    {
        path: '/contentAlbum/list',
        name: 'contentAlbum',
        component: () => import('@/views/contentAlbum/list'),
    },
    {
        path: '/contentAlbum/detail',
        name: 'contentAlbumDetail',
        component: () => import('@/views/contentAlbum/detail'),
    },
    {
        path: '/contentAlbum/comment',
        name: 'contentAlbumComment',
        component: () => import('@/views/contentAlbum/comment'),
    },
    {
        path: '/red/list',
        name: 'redList',
        component: () => import('@/views/red/list'),
    },
    {
        path: '/red/index',
        name: 'redIndex',
        component: () => import('@/views/red/index'),
    },
    {
        path: '/red/prizeList',
        name: 'redPrizeList',
        component: () => import('@/views/red/prizeList'),
    },
    {
        path: '/prize/my',
        redirect: '/red/prizeIndex',
    },
    addLoginMockMiddleware(
        '/',
        addMultiPlatformForceAuthMiddleware('/', {
            path: 'red/prizeIndex',
            name: 'redPrizeIndex',
            component: () => import('@/views/red/prizeIndex.vue'),
        }),
    ),
    {
        path: '/red/shopDetail',
        name: 'redShopDetail',
        component: () => import('@/views/red/shopDetail'),
    },
    {
        path: '/red/prize',
        name: 'redPrize',
        component: () => import('@/views/red/prize'),
    },
    {
        path: '/red/address',
        name: 'redPrizeAddress',
        component: () => import('@/views/red/address'),
    },
    {
        path: '/privacy/index',
        name: 'privacyIndex',
        component: () => import('@/views/privacy/index'),
    },
    {
        path: '/privacy/policy',
        name: 'privacyPolicy',
        component: () => import('@/views/privacy/policy'),
    },
    {
        path: '/privacy/agreement',
        name: 'privacyAgreement',
        component: () => import('@/views/privacy/agreement'),
    },
    {
        path: '/privacy/third',
        name: 'privacyThird',
        component: () => import('@/views/privacy/third'),
    },
    {
        path: '/playback/index',
        name: 'playbackIndex',
        component: () => import('@/views/playback/index'),
    },
    {
        path: '/playback/emcee',
        name: 'playbackEmcee',
        component: () => import('@/views/playback/emcee'),
    },
    {
        path: '/playback/album',
        name: 'playbackAlbum',
        component: () => import('@/views/playback/album'),
    },
    {
        path: '/playback/audio',
        name: 'playbackAudio',
        component: () => import('@/views/playback/audio'),
    },
    {
        path: '/rushBuy/list',
        name: 'rushBuyList',
        component: () => import('@/views/rushBuy/list'),
    },
    {
        path: '/rushBuy/index',
        name: 'rushBuyIndex',
        component: () => import('@/views/rushBuy/index'),
    },
    {
        path: '/programPlaying/index',
        name: 'programPlayingIndex',
        component: () => import('@/views/programPlaying/index'),
    },
    {
        path: '/logout/index',
        name: 'logoutIndex',
        component: () => import('@/views/logout/index'),
    },
    {
        path: '/logout/account',
        name: 'logoutAccount',
        component: () => import('@/views/logout/account'),
    },
    {
        path: '/logout/other',
        name: 'logoutOther',
        component: () => import('@/views/logout/other'),
    },
    {
        path: '/logout/phone',
        name: 'logoutPhone',
        component: () => import('@/views/logout/phone'),
    },
    {
        path: '/logout/protocol',
        name: 'logoutProtocol',
        component: () => import('@/views/logout/protocol'),
    },
    {
        path: '/logout/verify',
        name: 'logoutVerify',
        component: () => import('@/views/logout/verify'),
    },
    {
        path: '/programAd/index',
        name: 'programAd',
        component: () => import('@/views/programAd/index'),
    },
    addMultiPlatformQuiteAuthMiddleware('/', {
        path: '/enroll/list',
        name: 'enrollList',
        component: () => import('@/views/enroll/list'),
    }),
    addLoginMockMiddleware('/', addMultiPlatformQuiteAuthMiddleware('/', {
        path: 'enroll/index',
        name: 'enrollIndex',
        component: () => import('@/views/enroll/index'),
    })),
    addMultiPlatformForceAuthMiddleware('/', {
        path: '/enroll/emcee',
        name: 'enrollEmcee',
        component: () => import('@/views/enroll/emcee'),
    }),
    addMultiPlatformForceAuthMiddleware('/', {
        path: '/enroll/detail',
        name: 'enrollDetail',
        component: () => import('@/views/enroll/detail'),
    }),
    {
        path: '/verification/verifyJs',
        name: 'verifyJs',
        component: () => import('@/views/verification/verifyJs'),
    },
    {
        path: '/verification/verifyAction',
        name: 'verifyAction',
        component: () => import('@/views/verification/verifyAction'),
    },
    {
        path: '/verification/verifyActionReceive',
        name: 'verifyActionReceive',
        component: () => import('@/views/verification/verifyActionReceive'),
    },
    {
        path: '/surplusUpgrade/index',
        name: 'surplusUpgradeIndex',
        component: () => import('@/views/surplusUpgrade/index'),
    },
    {
        path: '/philharmonic/index',
        name: 'philharmonicIndex',
        component: () => import('@/views/philharmonic/index'),
    },
    {
        path: '/philharmonic/ticket',
        name: 'philharmonicTicket',
        component: () => import('@/views/philharmonic/ticket'),
    },
    {
        path: '/actionMap/index',
        name: 'actionMapIndex',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/actionMap/index'),
    },
    {
        path: '/actionMap/list',
        name: 'actionMapList',
        component: () => import('@/views/actionMap/list'),
    },
    {
        path: '/election/index',
        name: 'kbElectionIndex',
        component: () => import('@/views/election/index'),
    },
    {
        path: '/election/detail',
        name: 'kbElectionDetail',
        component: () => import('@/views/election/detail'),
    },
    {
        path: '/park/index',
        name: 'parkIndex',
        redirect: '/park/home',
    },
    {
        path: '/park/home',
        name: 'parkHome',
        component: () => import('@/views/park/index'),
    },
    {
        path: '/park/index2',
        name: 'parkIndex2',
        component: () => import('@/views/park/index2'),
    },
    {
        path: '/chediandian/index',
        name: 'kbChediandianIndex',
        component: () => import('@/views/chediandian/index'),
    },
    {
        path: '/chediandian/map',
        name: 'kbChediandianMap',
        component: () => import('@/views/chediandian/map'),
    },
    {
        path: '/chediandian/process',
        name: 'kbChediandianProcess',
        component: () => import('@/views/chediandian/process'),
    },
    {
        path: '/chediandian/order',
        name: 'kbChediandianOrder',
        component: () => import('@/views/chediandian/order'),
    },
    {
        path: '/chediandian/pay',
        name: 'kbChediandianPay',
        component: () => import('@/views/chediandian/pay'),
    },
    {
        path: '/userAddress/index',
        name: 'userAddress',
        component: () => import('@/views/userAddress/index'),
    },
    {
        path: '/experimental/index',
        name: 'kbExperimentalIndex',
        component: () => import('@/views/experimental/index'),
    },
    {
        path: '/experimental/list',
        name: 'kbExperimentalList',
        component: () => import('@/views/experimental/list'),
    },
    {
        path: '/page/car/bindNo',
        component: () => import('@/views/page/car/bindNoCar'),
    },
    {
        path: '/temp/icif/2023',
        name: 'kbICIF2023',
        component: () => import('@/views/temp/ICIF/2023/index.vue'),
    },
    {
        path: '/temp/festivaloflive/index',
        name: 'kbFestivalOfLiveIndex',
        component: () => import('@/views/temp/festivaloflive/2020/index.vue'),
    },
    {
        path: '/temp/festivaloflive/enroll',
        name: 'kbFestivalOfLiveEnroll',
        component: () => import('@/views/temp/festivaloflive/2020/enroll.vue'),
    },
    {
        path: '/temp/festivaloflive/photo',
        name: 'kbFestivalOfLivePhoto',
        component: () => import('@/views/temp/festivaloflive/2020/photo.vue'),
    },
    {
        path: '/temp/festivaloflive2021/index',
        name: 'kbFestivalOfLive2021Index',
        component: () => import('@/views/temp/festivaloflive/2021/index.vue'),
    },
    {
        path: '/temp/festivaloflive2021/photo',
        name: 'kbFestivalOfLive2021Photo',
        component: () => import('@/views/temp/festivaloflive/2021/photo.vue'),
    },
    addMultiPlatformQuiteAuthMiddleware('/', {
        path: 'temp/festivaloflive_2022',
        component: () => import('@/views/temp/festivaloflive/2022/index.vue'),
    }),
    addLoginMockMiddleware(
        '/',
        addMultiPlatformQuiteAuthMiddleware('/', [
            {
                path: '/temp/festivaloflive_2023',
                name: 'kbFestivalOfLive2023Index',
                component: () => import('@/views/temp/festivaloflive/2023/index.vue'),
            },
            {
                path: '/temp/festivaloflive_2023_gift_list',
                name: 'kbFestivalOfLive2023GiftList',
                component: () => import('@/views/temp/festivaloflive/2023/giftListPage/index.vue'),
            },
        ]),
    ),

    {
        path: '/temp/springcar/index',
        name: 'kbSpringCarIndex',
        component: () => import('@/views/temp/springcar/index'),
    },
    {
        path: '/temp/spring2022/index',
        name: 'kbSpring2022Index',
        component: () => import('@/views/temp/spring2022/index'),
    },
    {
        path: '/temp/spring2022/test',
        name: 'kbSpring2022test',
        component: () => import('@/views/temp/spring2022/test'),
    },
    {
        path: '/temp/qiche/bang',
        name: 'qicheBang',
        component: () => import('@/views/temp/qiche/bang'),
    },
    {
        path: '/temp/qiche/detail',
        name: 'qicheDetail',
        component: () => import('@/views/temp/qiche/detail'),
    },
    {
        path: '/temp/xinghe/index',
        name: 'kbXingHeIndex',
        component: () => import('@/views/temp/xinghe/index'),
    },
    {
        path: '/temp/summercar/index',
        name: 'kbSummerCarIndex',
        component: () => import('@/views/temp/summercar/index'),
    },
    {
        path: '/temp/property/index',
        name: 'kbPropertyIndex',
        component: () => import('@/views/temp/property/index'),
    },
    {
        path: '/temp/xinghe/houses',
        name: 'kbXingHeHouses',
        component: () => import('@/views/temp/xinghe/houses'),
    },
    {
        path: '/temp/civilized/index',
        name: 'kbCivilizedIndex',
        component: () => import('@/views/temp/civilized/index'),
    },
    {
        path: '/temp/civilization/index',
        name: 'kbCivilizationIndex',
        component: () => import('@/views/temp/civilization/index'),
    },
    {
        path: '/temp/civilization/cleanPlate',
        name: 'kbCivilizationCleanPlate',
        component: () => import('@/views/temp/civilization/cleanPlate'),
    },
    {
        path: '/temp/civilization/ranking',
        name: 'kbCivilizationRanking',
        component: () => import('@/views/temp/civilization/ranking'),
    },
    {
        path: '/temp/civilization/show',
        name: 'kbCivilizationShow',
        component: () => import('@/views/temp/civilization/show'),
    },
    {
        path: '/temp/autumn/index',
        name: 'kbAutumnIndex',
        component: () => import('@/views/temp/autumn/index'),
    },
    {
        path: '/temp/furniture/index',
        name: 'kbFurnitureIndex',
        component: () => import('@/views/temp/furniture/index'),
    },
    {
        path: '/temp/furniture/static',
        name: 'kbFurnitureStatic',
        component: () => import('@/views/temp/furniture/static'),
    },
    {
        path: '/temp/womenday/index',
        name: 'kbWomenDayIndex',
        component: () => import('@/views/temp/womenday/index'),
    },
    {
        path: '/temp/participant/index',
        name: 'participantIndex',
        component: () => import('@/views/temp/participant/index'),
    },
    {
        path: '/temp/index/float',
        component: () => import('@/views/temp/index/floatIndex'),
    },
    addMultiPlatformQuiteAuthMiddleware(
        '/',
        addRefreshFullpathMiddleware(
            '/',
            addLoginGuideMiddleware('/', {
                path: '/temp/badModelCar5/list',
                component: () => import('@/views/temp/badModelCar5/list'),
            }),
        ),
    ),
    addLoginMockMiddleware(
        '/',
        addMultiPlatformForceAuthMiddleware('/temp/cicaf19th', [
            {
                path: 'index',
                component: () => import('@/views/temp/cicaf/19th/index'),
            },
            {
                path: 'enroll',
                component: () => import('@/views/temp/cicaf/19th/enroll'),
            },
            {
                path: 'floatParade/election',
                component: () => import('@/views/temp/cicaf/19th/floatParade/election'),
            },
            {
                path: 'floatParade/candidate',
                props: (route) => ({ ...route.query }),
                component: () => import('@/views/temp/cicaf/19th/floatParade/candidate'),
            },
            {
                path: 'myEnrollList',
                component: () => import('@/views/temp/cicaf/19th/myEnrollList'),
            },
            {
                path: 'myEnrollInfo',
                component: () => import('@/views/temp/cicaf/19th/myEnrollInfo'),
            },
            {
                path: 'shopList',
                component: () => import('@/views/temp/cicaf/19th/shopList'),
            },
            {
                path: 'newsList',
                component: () => import('@/views/temp/cicaf/19th/newsList'),
            },
            {
                path: 'newsInfo/:articleId',
                props: true,
                component: () => import('@/views/temp/cicaf/19th/newsInfo'),
            },
            {
                path: 'chinaNationalStyle',
                props: true,
                component: () => import('@/views/temp/cicaf/19th/chinaNationalStyle/index.vue'),
            },
            {
                path: 'voiceActor',
                props: true,
                component: () => import('@/views/temp/cicaf/19th/voiceActor/index.vue'),
            },
            {
                path: 'voiceActor/introduce',
                props: true,
                component: () => import('@/views/temp/cicaf/19th/voiceActor/introduce.vue'),
            },
            {
                path: 'voiceActor/reservation',
                props: true,
                component: () => import('@/views/temp/cicaf/19th/voiceActor/reservation.vue'),
            },
            {
                path: 'voiceActor/myEnroll',
                props: true,
                component: () => import('@/views/temp/cicaf/19th/voiceActor/my-enroll.vue'),
            },
            {
                path: 'voiceActor/myReserve',
                props: true,
                component: () => import('@/views/temp/cicaf/19th/voiceActor/my-reserve.vue'),
            },
            {
                path: 'voiceActor/myReserveDetail/:reserveId',
                props: true,
                component: () => import('@/views/temp/cicaf/19th/voiceActor/my-reserve-detail.vue'),
            },
            {
                path: 'voiceActor/myEnrollDetail/:enrollId',
                props: true,
                component: () => import('@/views/temp/cicaf/19th/voiceActor/my-enroll-detail.vue'),
            },
        ]),
    ),
    // addLoginMockMiddleware(
    //     '/',
    addMultiPlatformForceAuthMiddleware('/temp/notIllegalClock4', [
        {
            path: 'index',
            component: () => import('@/views/temp/notIllegalClockAllSinceForth/notIllegalClock4/index'),
        },
        {
            path: 'question',
            component: () => import('@/views/temp/notIllegalClockAllSinceForth/notIllegalClock4/question/index'),
        },
        {
            path: 'shop',
            component: () => import('@/views/temp/notIllegalClockAllSinceForth/notIllegalClock4/shop/index'),
        },
        {
            path: 'trans-card',
            component: () => import('@/views/temp/notIllegalClockAllSinceForth/notIllegalClock4/transCard/index'),
        },
        {
            path: 'collect-all',
            component: () => import('@/views/temp/notIllegalClockAllSinceForth/notIllegalClock4/collectAll/index'),
        },
    ]),
    // ),

    addMultiPlatformQuiteAuthMiddleware('/temp/notIllegalClock3', [
        {
            path: 'index',
            component: () => import('@/views/temp/notIllegalClock3/index'),
        },
        {
            path: 'question',
            component: () => import('@/views/temp/notIllegalClock3/question'),
        },
        {
            path: 'shop',
            component: () => import('@/views/temp/notIllegalClock3/shop'),
        },
        {
            path: 'rank',
            component: () => import('@/views/temp/notIllegalClock3/rank'),
        },
        {
            path: 'myRank',
            component: () => import('@/views/temp/notIllegalClock3/myRank'),
        },
        {
            path: 'share',
            component: () => import('@/views/temp/notIllegalClock3/share'),
        },
        {
            path: 'shared',
            component: () => import('@/views/temp/notIllegalClock3/shared'),
        },
    ]),
    {
        path: '/temp/notIllegalClock2/endindex',
        name: 'endindexNotIllegalClock2',
        component: () => import('@/views/temp/notIllegalClock2/endindex'),
    },
    {
        path: '/temp/notIllegalClock2/floatindex',
        name: 'floatindexNotIllegalClock2',
        component: () => import('@/views/temp/notIllegalClock2/floatindex'),
    },
    {
        path: '/temp/notIllegalClock2',
        component: () => import('@/middleware/open-in-browser/index.vue'),
        children: [
            addMultiPlatformQuiteAuthMiddleware(
                '/',
                addLoginGuideMiddleware('/', [
                    {
                        path: 'index',
                        component: () => import('@/views/temp/notIllegalClock2/index'),
                    },
                    {
                        path: 'question',
                        component: () => import('@/views/temp/notIllegalClock2/question'),
                    },
                    {
                        path: 'shop',
                        component: () => import('@/views/temp/notIllegalClock2/shop'),
                    },
                ]),
            ),
        ],
    },
    {
        path: '/temp/notIllegalClock/index',
        name: 'indexNotIllegalClock',
        component: () => import('@/views/temp/notIllegalClock/index'),
    },
    {
        path: '/temp/notIllegalClock/gotoLastTaskUrl',
        name: 'gotoLastTaskUrlNotIllegalClock',
        component: () => import('@/views/temp/notIllegalClock/gotoLastTaskUrl'),
    },
    {
        path: '/temp/notIllegalClock/luckDrawList',
        name: 'luckDrawListNotIllegalClock',
        component: () => import('@/views/temp/notIllegalClock/luckDrawList'),
    },
    {
        path: '/temp/notIllegalClock/test1',
        component: () => import('@/views/temp/notIllegalClock/test1'),
    },
    {
        path: '/temp/notIllegalClock/test2',
        component: () => import('@/views/temp/notIllegalClock/test2'),
    },
    {
        path: '/temp/notIllegalClock/test3',
        component: () => import('@/views/temp/notIllegalClock/test3'),
    },
    {
        path: '/temp/newyear2024/audiored',
        component: () => import('@/views/temp/newyear2024/audiored'),
    },
    {
        path: '/temp/newyear2023/audiored',
        component: () => import('@/views/temp/newyear2023/audiored'),
    },
    {
        path: '/temp/springfestival2023/floatIndex',
        component: () => import('@/views/temp/springfestival2023/floatIndex'),
    },
    {
        path: '/temp/springfestival2023/luckDraw',
        component: () => import('@/views/temp/springfestival2023/luckDraw'),
    },
    addMultiPlatformQuiteAuthMiddleware('/temp/springfestival2023', [
        {
            path: 'index',
            component: () => import('@/views/temp/springfestival2023/index'),
        },
        {
            path: 'end',
            component: () => import('@/views/temp/springfestival2023/end'),
        },
    ]),
    addMultiPlatformForceAuthMiddleware('/temp/springfestival2023', [
        {
            path: 'blessingTicketDetail',
            component: () => import('@/views/temp/springfestival2023/blessingTicketDetail.vue'),
        },
        {
            path: 'myWish',
            component: () => import('@/views/temp/springfestival2023/myWish'),
        },
        {
            path: 'wish',
            component: () => import('@/views/temp/springfestival2023/wish'),
        },
        {
            path: 'getWish',
            component: () => import('@/views/temp/springfestival2023/getWish'),
        },
        {
            path: 'knowledge',
            component: () => import('@/views/temp/springfestival2023/knowledge'),
        },
        {
            path: 'myCoupon',
            component: () => import('@/views/temp/springfestival2023/myCoupon'),
        },
        {
            path: 'shop',
            component: () => import('@/views/temp/springfestival2023/shop'),
        },
    ]),
    {
        path: '/temp/exposePrize/index',
        component: () => import('@/views/temp/exposePrize/index'),
    },
    {
        path: '/feimaPay/index',
        name: 'feimaPayIndex',
        component: () => import('@/views/feimaPay/index'),
    },
    {
        path: '/zuimeisiji',
        name: 'zuimeisijiList',
        redirect: '/zuimeisiji/list',
    },
    {
        path: '/zuimeisiji/list',
        name: 'zuimeisijiList',
        component: () => import('@/views/zuimeisiji/list'),
        meta: {
            title: '最美司机评选',
            keepAlive: true, // 需要被缓存
        },
    },
    {
        path: '/zuimeisiji/detail',
        name: 'zuimeisijiDetail',
        component: () => import('@/views/zuimeisiji/detail'),
        meta: {
            title: '最美司机评选',
            keepAlive: false, // 需要被缓存
        },
    },

    {
        path: '/splash/index',
        name: 'kbSplashIndex',
        component: () => import('@/views/splash/index'),
    },
    {
        path: '/program/emceeRank',
        name: 'kbProgramEmceeRank',
        component: () => import('@/views/program/emceeRank'),
    },
    {
        path: '/program/programRank',
        name: 'kbProgramRank',
        component: () => import('@/views/program/programRank'),
    },
    {
        path: '/program/rewardList',
        name: 'kbProgramRewardList',
        component: () => import('@/views/program/rewardList'),
    },
    {
        path: '/web/index',
        name: 'kbWebIndex',
        component: () => import('@/views/web/index'),
    },
    {
        path: '/trafficBan/index',
        redirect: '/trafficBan/preview',
    },
    {
        path: '/trafficBan/preview',
        component: () => import('@/views/TrafficBan/index.vue'),
    },
    {
        path: '/trafficBan/map',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/TrafficBan/map.vue'),
    },
    {
        path: '/safeguard/detail',
        name: 'kbSafeguardDetail',
        component: () => import('@/views/safeguard/detail'),
    },

    {
        path: '/wentichezhan',
        name: 'wentichezhanList',
        redirect: '/wentichezhan/list',
    },
    {
        path: '/wxlogin',
        name: 'wxlogin',
        component: () => import('@/views/wxLogin/index'),
    },
    {
        path: '/wxlogin/login',
        name: 'wxLogin',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/wxLogin/login'),
    },
    {
        path: '/wxlogin/regesiter',
        name: 'wxRegesiter',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/wxLogin/register'),
    },
    {
        path: '/zhaodaole',
        name: 'zhaodaole',
        component: () => import('@/views/zhaodaole/zhaodaoleIndex'),
        children: [
            {
                path: '/zhaodaole/list',
                name: 'zhaodaoleList',
                component: () => import('@/views/zhaodaole/list/zhaodaoleList'),
                meta: {
                    title: '找到了',
                    showTab: true,
                    keepAlive: true, // 需要被缓存
                },
            },
            {
                path: '/zhaodaole/mapSelecter',
                name: 'zhaodaoleMapSelecter',
                component: () => import('@/views/zhaodaole/list/zhaodaoleMapSelect'),
                meta: {
                    title: '找到了',
                    showTab: false,
                    keepAlive: false,
                },
            },
            {
                path: '/zhaodaole/search',
                name: 'zhaodaoleSearch',
                component: () => import('@/views/zhaodaole/list/zhaodaoleSearchPage'),
                meta: {
                    title: '找到了',
                    showTab: false,
                    keepAlive: true,
                },
            },
            {
                path: '/zhaodaole/list/detail',
                name: 'zhaodaoleDetail',
                component: () => import('@/views/zhaodaole/list/zhaodaoleDetail'),
                meta: {
                    title: '找到了',
                    showTab: false,
                    keepAlive: false,
                },
            },
            {
                path: '/zhaodaole/map',
                name: 'zhaodaoleMap',
                component: () => import('@/views/zhaodaole/map/zhaodaoleMap'),
                meta: {
                    title: '找到了',
                    showTab: true,
                    keepAlive: true, // 需要被缓存
                },
            },
            {
                path: '/zhaodaole/mine',
                name: 'zhaodaoleMine',
                component: () => import('@/views/zhaodaole/mine/zhaodaoleMine'),
                meta: {
                    title: '找到了',
                    showTab: true,
                    keepAlive: true, // 需要被缓存
                },
            },
        ],
    },
    {
        path: '/cpc100/index',
        name: 'cpc100Index',
        component: () => import('@/views/cpc100/index'),
    },
    {
        path: '/cpc100/video',
        name: 'cpc100Video',
        component: () => import('@/views/cpc100/video'),
    },
    {
        path: '/agreement/agreement',
        name: 'agreementAgreement',
        component: () => import('@/views/agreement/agreement'),
    },
    {
        path: '/agreement/liability',
        name: 'agreementLiability',
        component: () => import('@/views/agreement/liability'),
    },
    {
        path: '/agreement/androidSetting',
        name: 'agreementAndroidSetting',
        component: () => import('@/views/agreement/androidSetting'),
    },
    {
        path: '/agreement/expert',
        name: 'agreementExpert',
        component: () => import('@/views/agreement/expert'),
    },
    {
        path: '/agreement/issuebook',
        name: 'agreementIssuebook',
        component: () => import('@/views/agreement/issuebook'),
    },
    {
        path: '/agreement/safeguard',
        name: 'agreementSafeguard',
        component: () => import('@/views/agreement/safeguard'),
    },
    {
        path: '/agreement/withdraw',
        name: 'agreementWithdraw',
        component: () => import('@/views/agreement/withdraw'),
    },
    {
        path: '/appDownload/index',
        name: 'appDownload',
        component: () => import('@/views/appDownload/index'),
    },
    {
        path: '/appDownload/promotionLink',
        name: 'appDownloadPromotionLink',
        component: () => import('@/views/appDownload/promotion-link'),
    },
    {
        path: '/cash/list',
        name: 'cashList',
        component: () => import('@/views/cash/list'),
    },
    {
        path: '/hezuo',
        redirect: '/hezuo/index',
    },
    {
        path: '/hezuo/index',
        name: 'hezuoIndex',
        component: () => import('@/views/hezuo/index'),
    },
    {
        path: '/score/myKb',
        name: 'scoreMyKb',
        component: () => import('@/views/score/myKb'),
    },
    {
        path: '/trafficCode/index',
        name: 'trafficCodeIndex',
        component: () => import('@/views/trafficCode/index'),
    },
    {
        path: '/trafficCode/problem',
        name: 'trafficCodeProblem',
        component: () => import('@/views/trafficCode/problem'),
    },
    {
        path: '/trafficCode/form',
        name: 'trafficCodeForm',
        component: () => import('@/views/trafficCode/form'),
    },
    {
        path: '/trafficCode/study',
        name: 'trafficCodeStudy',
        component: () => import('@/views/trafficCode/study'),
    },
    {
        path: '/banner/detail',
        name: 'bannerDetail',
        component: () => import('@/views/banner/detail'),
    },
    {
        path: '/yaohao/list',
        name: 'yaohaoList',
        component: () => import('@/views/yaohao/list'),
    },
    {
        path: '/yaohao/add',
        name: 'yaohaoAdd',
        component: () => import('@/views/yaohao/add'),
    },
    {
        path: '/yiliaojigoupingxuan/index',
        name: 'yiliaojigoupingxuan',
        component: () => import('@/views/xuzhouYiLiaoPingXuan/index'),
    },
    {
        path: '/yiliaojigoupingxuan/detail',
        name: 'yiliaojigoupingxuanDetail',
        component: () => import('@/views/xuzhouYiLiaoPingXuan/detail'),
    },

    {
        path: '/wangyuechepingxuan/index',
        name: 'wangyuechepingxuan',
        component: () => import('@/views/wangYueCheSiJiPingXuan/index'),
    },
    {
        path: '/wangyuechepingxuan/index',
        name: 'wangyuechepingxuanDetail',
        component: () => import('@/views/wangYueCheSiJiPingXuan/detail'),
    },
    {
        path: '/components/map',
        name: 'componentsMap',
        component: () => import('@/views/components/map'),
    },
    {
        path: '/hbx/index',
        name: 'hbxIndex',
        component: () => import('@/views/hbx/index'),
        meta: {
            keepAlive: true,
        },
    },
    {
        path: '/shop',
        name: 'shoplist',
        redirect: '/shop/order',
    },
    {
        path: '/shop/order',
        name: 'shopOrder',
        component: () => import('@/views/shop/order'),
        meta: {
            title: '订单列表',
            keepAlive: true, // 需要被缓存
        },
    },
    {
        path: '/shop/detail',
        name: 'shopDetail',
        component: () => import('@/views/shop/detail'),
        meta: {
            title: '商品详情',
        },
    },
    {
        path: '/shop/addorder',
        name: 'shopAddOrder',
        component: () => import('@/views/shop/addorder'),
        meta: {
            title: '填写订单',
        },
    },
    {
        path: '/shop/addressList',
        name: 'shopAddressList',
        component: () => import('@/views/shop/addressList'),
        meta: {
            title: '地址管理',
        },
    },
    {
        path: '/shop/noteList',
        name: 'shopNoteList',
        component: () => import('@/views/shop/noteList'),
        meta: {
            title: '评价列表',
        },
    },
    {
        path: '/map/index',
        name: 'mapIndex',
        component: () => import('@/views/map/index'),
        meta: {
            title: '地图',
        },
    },
    {
        path: '/example/index',
        name: 'exampleIndex',
        component: () => import('@/views/example/index'),
    },
    {
        path: '/covid/index',
        name: 'covidIndex',
        redirect: { path: '/covid/combine', query: { covid_type: 2 } },
    },
    {
        path: '/covid/grid',
        name: 'covidGrid',
        redirect: '/covid/combine',
    },
    {
        path: '/covid/combine',
        name: 'covidCombine',
        component: () => import('@/views/covid/combine/index'),
    },
    {
        path: '/covid/telsearch',
        name: 'indexTelsearchCovid',
        component: () => import('@/views/covid/telsearch/index'),
    },
    {
        path: '/covid/telsearch/list',
        name: 'listTelsearchCovid',
        component: () => import('@/views/covid/telsearch/list'),
    },
    {
        path: '/billboard/index',
        name: 'billboardIndex',
        component: () => import('@/views/billboard/index'),
        meta: {
            keepAlive: true, // 需要被缓存
        },
    },
    {
        path: '/billboard/birthday',
        name: 'billboardBirthday',
        component: () => import('@/views/billboard/birthday'),
        meta: {
            keepAlive: true, // 需要被缓存
        },
    },
    {
        path: '/billboard/birthday/:name',
        name: 'billboardBirthday',
        component: () => import('@/views/billboard/birthday'),
        meta: {
            keepAlive: true, // 需要被缓存
        },
    },
    {
        path: '/billboard/staff',
        name: 'billboardstaff',
        component: () => import('@/views/billboard/staff'),
        meta: {
            keepAlive: true, // 需要被缓存
        },
    },
    {
        path: '/billboard/pic',
        name: 'billboardPic',
        component: () => import('@/views/billboard/pic'),
        meta: {
            keepAlive: true, // 需要被缓存
        },
    },
    {
        path: '/billboard/video',
        name: 'billboardVideo',
        component: () => import('@/views/billboard/video'),
        meta: {
            keepAlive: true, // 需要被缓存
        },
    },
    {
        path: '/videolive/index',
        name: 'videoLiveIndex',
        component: () => import('@/views/videolive/detail/index'),
    },
    {
        path: '/toilet',
        name: 'toilet',
        component: () => import('@/views/toilet/home'),
    },
    {
        path: '/arbitraryGate',
        name: 'arbitraryGate',
        component: () => import('@/views/arbitraryGate/home'),
    },
    {
        path: '/gaokaoxia_2022',
        name: 'gaokaoxia_2022',
        props: {
            noteMapKey: 'gaokaoxia_2022',
        },
        component: () => import('@/views/gaokaoxia_2022/index'),
    },
    {
        path: '/youzan',
        name: 'youzan',
        component: () => import('@/views/youzan/auth/index'),
        children: [
            {
                path: 'mobile/self',
                component: () => import('@/views/youzan/mobile/self/index'),
            },
            {
                path: 'mobile/bind',
                component: () => import('@/views/youzan/mobile/bind/index'),
            },
            {
                path: 'order/list',
                component: () => import('@/views/youzan/order/list/index'),
            },
        ],
    },
    {
        path: '/under_maintenance',
        name: 'underMaintenance',
        component: () => import('@/views/underMaintenance/index'),
    },
    {
        path: '/convenience-service',
        name: 'ConvenienceService',
        component: () => import('@/views/convenience-service/index'),
    },
    {
        path: '/convenience-service/grid',
        name: 'ConvenienceServiceGrid',
        component: () => import('@/views/convenience-service/grid'),
    },
    {
        path: '/convenience-service/doorway',
        name: 'ConvenienceServiceDoorway',
        component: () => import('@/views/convenience-service/doorway.vue'),
    },
    // 历史遗留性问题,请勿短时间内移除,涉及到后端省选埋点
    {
        path: '/pages/hoolo/content/list',
        redirect: '/hoolo/content/list',
    },
    // 历史遗留性问题,请勿短时间内移除,涉及到后端省选埋点
    {
        path: '/pages/hoolo/content/detail',
        redirect: '/hoolo/content/detail',
    },
    {
        meta: {
            keepAlive: true, // 需要被缓存
        },
        name: 'HooloContentList',
        path: '/hoolo/content/list',
        component: () => import('@/views/hoolo/content/list'),
    },
    {
        name: 'HooloContentDetail',
        path: '/hoolo/content/detail',
        component: () => import('@/views/hoolo/content/detail/index'),
    },
    {
        path: '/temp/notIllegalClock/luckDrawList',
        name: 'luckDrawListNotIllegalClock',
        component: () => import('@/views/temp/notIllegalClock/luckDrawList'),
    },
    {
        path: '/page/realtimeArticleListDataTmuyun',
        component: () => import('@/views/page/realtimeArticleListDataTmuyun'),
    },
    {
        path: '/page/imagelayer',
        name: 'imagelayerPage',
        component: () => import('@/views/page/imagelayer'),
    },
    {
        path: '/page/imagelayerPc',
        name: 'imagelayerPagePc',
        component: () => import('@/views/page/imagelayerPc'),
    },
    addMultiPlatformForceAuthMiddleware('/temp/goldenBean202310', [
        {
            path: '/',
            component: () => import('@/views/temp/goldenBean202310/index'),
        },
        {
            path: 'shop',
            component: () => import('@/views/temp/goldenBean202310/shop'),
        },
    ]),
    addMultiPlatformQuiteAuthMiddleware('/temp/qingliang2023', [
        {
            path: '/',
            component: () => import('@/views/temp/qingliang2023/index'),
        },
        {
            path: 'pc',
            component: () => import('@/views/temp/qingliang2023/indexPc'),
        },
    ]),
    {
        path: '/page/imagelayerPc',
        name: 'imagelayerPagePc',
        component: () => import('@/views/page/imagelayerPc'),
    },
    {
        path: '/page/activePosters',
        name: 'pageActivePosters',
        component: () => import('@/views/page/activePosters/index.vue'),
    },
    addLoginMockMiddleware(
        '/',
        addMultiPlatformQuiteAuthMiddleware('/election', [
            {
                path: 'truck-driver',
                name: 'electionTruckDriverList',
                component: () => import('@/views/election/middleware/election-state.vue'),
                props: {
                    election_key: 'hz_best_truck_driver_202209',
                },
                children: [
                    {
                        path: 'list',
                        name: 'electionTruckDriverList',
                        props: (route) => ({ election_key: 'hz_best_truck_driver_202209', ...route.query }),
                        component: () => import('@/views/election/truck-driver/list.vue'),
                    },
                ],
            },
            {
                path: 'all-driver',
                name: 'electionAllDriverList',
                component: () => import('@/views/election/middleware/election-state.vue'),
                props: {
                    election_key: 'hz_best_all_driver_202209',
                },
                children: [
                    {
                        path: 'list',
                        name: 'electionAllDriverList',
                        props: (route) => ({ election_key: 'hz_best_all_driver_202209', ...route.query }),
                        component: () => import('@/views/election/all-driver/list'),
                    },
                ],
            },
        ]),
    ),
    {
        path: '/page/sixOutstanding',
        name: 'pageSixOutstandingIndex',
        component: () => import('@/views/page/sixOutstanding/index.vue'),
    },
    {
        path: '/page/sixOutstanding/signUp',
        name: 'pageSixOutstandingSignUp',
        component: () => import('@/views/page/sixOutstanding/signUp.vue'),
    },
    {
        path: '/page/sixOutstanding/voteCategory',
        component: () => import('@/views/page/sixOutstanding/voteCategory.vue'),
    },
    addRefreshFullpathMiddleware('/page/sixOutstanding/voteList', {
        path: '',
        component: () => import('@/views/page/sixOutstanding/voteList.vue'),
    }),
    {
        path: '/page/sixOutstanding/voteInfo',
        component: () => import('@/views/page/sixOutstanding/voteInfo.vue'),
    },
    {
        path: '/activity-mix',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/activity-mix/home/index.vue'),
    },
    {
        path: '/activity-mix/tab',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/activity-mix/tab/index.vue'),
    },
    addMultiPlatformQuiteAuthMiddleware(
        '/temp/xingzb202309',
        addRefreshFullpathMiddleware('/', [
            {
                path: 'voteList',
                component: () => import('@/views/temp/xingzb202309/voteList.vue'),
            },
            {
                path: 'voteInfo',
                component: () => import('@/views/temp/xingzb202309/voteInfo.vue'),
            },
        ]),
    ),
    addRefreshFullpathMiddleware('/page/apuCup', [
        {
            path: 'voteCategory',
            component: () => import('@/views/page/apuCup/voteCategory.vue'),
        },
        {
            path: 'voteList',
            component: () => import('@/views/page/apuCup/voteList.vue'),
        },
        {
            path: 'voteInfo',
            component: () => import('@/views/page/apuCup/voteInfo.vue'),
        },
    ]),
    addLoginMockMiddleware(
        '/',
        addMultiPlatformForceAuthMiddleware(
            '/',
            addRefreshFullpathMiddleware('/page/apuCup202311', [
                {
                    path: 'voteCategory',
                    component: () => import('@/views/page/apuCup202311/voteCategory.vue'),
                },
                {
                    path: 'voteList',
                    component: () => import('@/views/page/apuCup202311/voteList.vue'),
                },
                {
                    path: 'voteInfo',
                    component: () => import('@/views/page/apuCup202311/voteInfo.vue'),
                },
            ]),
        ),
    ),
    addLoginMockMiddleware(
        '/',
        addMultiPlatformQuiteAuthMiddleware('/temp/principal-rank', [
            {
                path: 'list',
                component: () => import('@/views/temp/principalRank/index.vue'),
            },
            {
                path: 'detail',
                component: () => import('@/views/temp/principalRank/PrincipalDetail/index.vue'),
            },
        ]),
    ),
    addMultiPlatformQuiteAuthMiddleware('/temp/fifa-world-cup-2022', [
        {
            path: 'choose-team',
            component: () => import('@/views/temp/fifa-world-cup-2022/choose-team.vue'),
        },
        {
            path: '',
            component: () => import('@/views/temp/fifa-world-cup-2022/home/index.vue'),
        },
        {
            path: 'quiz/today',
            component: () => import('@/views/temp/fifa-world-cup-2022/quiz/today.vue'),
        },
        {
            path: 'quiz/:id',
            props: true,
            component: () => import('@/views/temp/fifa-world-cup-2022/quiz/detail.vue'),
        },
        {
            path: 'quiz',
            component: () => import('@/views/temp/fifa-world-cup-2022/quiz/historical.vue'),
        },
        {
            path: 'my-team',
            component: () => import('@/views/temp/fifa-world-cup-2022/my-team.vue'),
        },
        {
            path: 'rank',
            component: () => import('@/views/temp/fifa-world-cup-2022/rank.vue'),
        },
        {
            path: 'rush',
            component: () => import('@/views/temp/fifa-world-cup-2022/rush/index.vue'),
        },
        {
            path: 'news',
            component: () => import('@/views/temp/fifa-world-cup-2022/news/index.vue'),
        },
        {
            path: 'news/:id',
            props: true,
            component: () => import('@/views/temp/fifa-world-cup-2022/news/index.vue'),
        },
    ]),
    addMultiPlatformQuiteAuthMiddleware('/temp/furniture-2023', [
        {
            path: '',
            component: () => import('@/views/temp/hengda-family-decoration/202302/index/index.vue'),
        },
        {
            path: 'shop',
            component: () => import('@/views/temp/hengda-family-decoration/202302/shop/index.vue'),
        },
    ]),
    addMultiPlatformForceAuthMiddleware('/points/detailed', [
        {
            path: '',
            component: () => import('@/views/points/detailed.vue'),
            props: (route) => ({ ...route.query }),
        },
    ]),
    {
        path: '/circle/note/:noteId',
        props: true,
        component: () => import('@/views/circle/note.vue'),
    },
    {
        path: '/circle/:threadId',
        props: true,
        component: () => import('@/views/circle/detail.vue'),
    },
    {
        path: '/temp/dance-competition',
        component: () => import('@/views/temp/dance-competition/index.vue'),
    },
    {
        path: '/temp/dance-competition/tips/:articleId',
        props: true,
        component: () => import('@/views/temp/dance-competition/tips.vue'),
    },
    {
        path: '/other/video-display',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/other/video-display.vue'),
    },
    {
        path: '/temp/hz-918-furniture-2023/ai/detail/:id',
        props: true,
        component: () => import('@/views/temp/hz-home-dco-challenge/2023/ai-conversion/detail.vue'),
    },
    addLoginMockMiddleware(
        '/',
        addMultiPlatformForceAuthMiddleware('/temp/hz-918-furniture-2023', [
            {
                path: '',
                component: () => import('@/views/temp/hz-home-dco-challenge/2023/index.vue'),
            },
            {
                path: 'shop',
                component: () => import('@/views/temp/hz-home-dco-challenge/2023/shop.vue'),
            },
            {
                path: 'ai/create',
                component: () => import('@/views/temp/hz-home-dco-challenge/2023/ai-conversion/create.vue'),
            },
        ]),
    ),
    {
        path: '/temp/hz-918-student-learning-tourism',
        component: () => import('@/views/temp/hz-918-student-learning-tourism/index.vue'),
    },
    {
        path: '/temp/exam-assistance-2023/action-map',
        component: () => import('@/views/temp/hz-exam-assistance/2023/action-map.vue'),
    },
    addMultiPlatformQuiteAuthMiddleware('/temp/exam-assistance-2023', [
        {
            path: '',
            component: () => import('@/views/temp/hz-exam-assistance/2023/index.vue'),
        },
        {
            path: 'blessing-bottle/:articleId',
            props: true,
            component: () => import('@/views/temp/hz-exam-assistance/2023/blessing-bottle.vue'),
        },
        {
            path: 'wishing-wall',
            component: () => import('@/views/temp/hz-exam-assistance/2023/wishing-wall.vue'),
        },
    ]),
    {
        path: '/temp/asian-games-19th',
        component: () => import('@/views/temp/asian-games-19th/index.vue'),
    },
    {
        path: '/temp/asian-games-19th/article',
        component: () => import('@/views/temp/asian-games-19th/article.vue'),
    },
    {
        path: '/temp/asian-games-19th/video-live',
        component: () => import('@/views/temp/asian-games-19th/video-live.vue'),
    },
    {
        path: '/temp/asian-games-19th/count',
        component: () => import('@/views/temp/asian-games-19th/count.vue'),
    },
    {
        path: '/temp/asian-games-19th/quiz',
        component: () => import('@/views/temp/asian-games-19th/quiz.vue'),
    },
    {
        path: '/temp/asian-games-19th/quiz-test',
        component: () => import('@/views/temp/asian-games-19th/quiz-test.vue'),
    },
    {
        path: '/temp/asian-games-19th/home-popup',
        component: () => import('@/views/temp/asian-games-19th/home-popup.vue'),
    },
    {
        path: '/temp/asian-games-19th/restriction',
        component: () => import('@/views/temp/asian-games-19th/restriction/index.vue'),
        redirect: '/trafficBan/preview',
    },
    {
        path: '/temp/asian-games-19th/restriction/review',
        component: () => import('@/views/temp/asian-games-19th/restriction/index.vue'),
    },
    {
        path: '/temp/asian-games-19th/restriction/map',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/temp/asian-games-19th/restriction/map/index.vue'),
    },
    {
        path: '/temp/asian-games-19th/awarded/:actionMapId',
        props: true,
        component: () => import('@/views/temp/asian-games-19th/awarded.vue'),
    },
    {
        path: '/headline',
        props: true,
        component: () => import('@/views/headline/home.vue'),
    },
    {
        path: '/headline/hangzhou',
        props: true,
        component: () => import('@/views/headline/hangzhou.vue'),
    },
    {
        path: '/neo-news/:articleId',
        props: true,
        component: () => import('@/views/neo-news/details/data-loader.vue'),
    },
    {
        path: '/reveal',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/reveal/index.vue'),
    },
    {
        path: '/reveal/program/:programId',
        props: true,
        component: () => import('@/views/reveal/program/index.vue'),
    },
    {
        path: '/reveal/program/:programId/history',
        props: (route) => ({ ...route.params, type: 'history' }),
        component: () => import('@/views/reveal/program/all.vue'),
    },
    {
        path: '/reveal/program/:programId/keynote',
        props: (route) => ({ ...route.params, type: 'keynote' }),
        component: () => import('@/views/reveal/program/all.vue'),
    },
    {
        path: '/reveal/schedule/:scheduleId',
        props: true,
        component: () => import('@/views/reveal/schedule/index-loader.vue'),
    },
    {
        path: '/video-clip/:clipId',
        props: true,
        component: () => import('@/views/video-clip/index-loader.vue'),
    },
    {
        path: '/tips-article/:articleId',
        props: true,
        component: () => import('@/views/tips-article/detailed.vue'),
    },
    addLoginMockMiddleware(
        '/',
        addMultiPlatformQuiteAuthMiddleware('/', {
            path: '/temp/asian-games-activitys/lighting-venues',
            component: () => import('@/views/temp/asian-games-activitys/lightingVenues/index.vue'),
        }),
    ),
    {
        path: '/temp/asian-cuisine-journey/2023',
        component: () => import('@/views/temp/asian-cuisine-journey/2023/home/index.vue'),
    },
    {
        path: '/temp/asian-cuisine-journey/2023/restaurant-list',
        component: () => import('@/views/temp/asian-cuisine-journey/2023/restaurant-list/data-loader.vue'),
    },
    {
        path: '/temp/asian-cuisine-journey/2023/foodie-video',
        component: () => import('@/views/temp/asian-cuisine-journey/2023/foodie-video/index.vue'),
    },
    addLoginMockMiddleware(
        '/',
        addMultiPlatformForceAuthMiddleware('/', {
            path: '/temp/asian-cuisine-journey/2023/gourmet-koi',
            component: () => import('@/views/temp/asian-cuisine-journey/2023/gourmet-koi/index.vue'),
        }),
    ),
    {
        path: '/temp/asian-cuisine-journey/2023/night-snacks',
        component: () => import('@/views/temp/asian-cuisine-journey/2023/night-snacks/index.vue'),
    },
    {
        path: '/temp/asian-cuisine-journey/2023/gourmet-koi/my-lucky-code',
        component: () => import('@/views/temp/asian-cuisine-journey/2023/gourmet-koi/my-lucky-code/index.vue'),
    },
    {
        path: '/temp/asian-cuisine-journey/2023/my-prize',
        component: () => import('@/views/temp/asian-cuisine-journey/2023/my-prize/index.vue'),
    },
    {
        path: '/contact/upsert',
        props: (route) => ({ ...route.query }),
        component: () => import('@/views/contact/upsert/index.vue'),
    },
    {
        path: '/temp/hz-theatre/12th',
        component: () => import('@/views/temp/hz-theatre/12th/index.vue'),
    },
    {
        path: '/temp/china-theatre/18th',
        component: () => import('@/views/temp/china-theatre/18th/home/index.vue'),
    },
    {
        path: '/temp/china-theatre/18th/trends',
        component: () => import('@/views/temp/china-theatre/18th/trends/index.vue'),
    },
    {
        path: '/temp/china-theatre/18th/ticket',
        component: () => import('@/views/temp/china-theatre/18th/ticket/index.vue'),
    },
    {
        path: '/temp/china-theatre/18th/kb-ticket',
        component: () => import('@/views/temp/china-theatre/18th/kb-ticket/index.vue'),
    },
    {
        path: '/temp/asianParaGames/4th',
        component: () => import('@/views/temp/asianParaGames/4th/home/index.vue'),
    },
    {
        path: '/temp/asianParaGames/4th/trends',
        component: () => import('@/views/temp/asianParaGames/4th/trends/index.vue'),
    },
    addLoginMockMiddleware(
        '/',
        addMultiPlatformQuiteAuthMiddleware('/temp/hengda-family-decoration/202311', [
            {
                path: '',
                component: () => import('@/views/temp/hengda-family-decoration/202311/home/index.vue'),
            },
            {
                path: 'invite',
                component: () => import('@/views/temp/hengda-family-decoration/202311/invite/index.vue'),
            },
            {
                path: 'invite/user/:targetUserId',
                props: true,
                component: () => import('@/views/temp/hengda-family-decoration/202311/invite/user/index.vue'),
            },
            {
                path: 'shop',
                component: () => import('@/views/temp/hengda-family-decoration/202311/shop/index.vue'),
            },
        ]),
    ),
    {
        path: '/temp/hengda-family-decoration/202402',
        component: () => import('@/views/temp/hengda-family-decoration/202402/index.vue'),
    },
    addMultiPlatformForceAuthMiddleware('/', {
        path: '/temp/hz-game-time-keeper',
        component: () => import('@/views/temp/hz-game-time-keeper/home/index.vue'),
    }),
    {
        path: '/temp/hz-game-time-keeper/rank',
        component: () => import('@/views/temp/hz-game-time-keeper/rank/index.vue'),
    },
    addLoginMockMiddleware(
        '/',
        addMultiPlatformForceAuthMiddleware('/', {
            path: 'temp/car-fengyun-ranking-2023-tenth',
            component: () => import('@/views/temp/qiche/fengyunRanking/2023/tenth'),
        }),
    ),
    addLoginMockMiddleware('/', {
        path: '/temp/hz-new-years-prayer/2024',
        component: () =>
            import(
                /* webpackChunkName: "hz-new-years-prayer" */ '@/views/temp/hz-new-years-prayer/2024/middleware/transition-router.vue'
                ),
        children: [
            addMultiPlatformQuiteAuthMiddleware('/', [
                {
                    path: '/',
                    component: () =>
                        import(/* webpackChunkName: "hz-new-years-prayer" */ '@/views/temp/hz-new-years-prayer/2024/home/index.vue'),
                },
                {
                    path: 'bless-detail/:fuCode',
                    props: true,
                    component: () =>
                        import(
                            /* webpackChunkName: "hz-new-years-prayer" */ '@/views/temp/hz-new-years-prayer/2024/bless-detail/index.vue'
                            ),
                },
            ]),
            addMultiPlatformForceAuthMiddleware('/', [
                {
                    path: 'write/step-1',
                    component: () =>
                        import(
                            /* webpackChunkName: "hz-new-years-prayer" */ '@/views/temp/hz-new-years-prayer/2024/write-bless/step-1/index.vue'
                            ),
                },
                {
                    path: 'write/step-2',
                    props: (route) => ({ ...route.query }),
                    component: () =>
                        import(
                            /* webpackChunkName: "hz-new-years-prayer" */ '@/views/temp/hz-new-years-prayer/2024/write-bless/step-2/index-loader.vue'
                            ),
                },
                {
                    path: 'write/step-3',
                    props: (route) => ({ ...route.query }),
                    component: () =>
                        import(
                            /* webpackChunkName: "hz-new-years-prayer" */ '@/views/temp/hz-new-years-prayer/2024/write-bless/step-3/index.vue'
                            ),
                },
                {
                    path: 'write/step-4',
                    props: (route) => ({ ...route.query }),
                    component: () =>
                        import(
                            /* webpackChunkName: "hz-new-years-prayer" */ '@/views/temp/hz-new-years-prayer/2024/write-bless/step-4/index.vue'
                            ),
                },
                {
                    path: 'my-bless',
                    component: () =>
                        import(
                            /* webpackChunkName: "hz-new-years-prayer" */ '@/views/temp/hz-new-years-prayer/2024/my-bless/index.vue'
                            ),
                },
            ]),
        ],
    }),
    addLoginMockMiddleware(
        '/',
        addMultiPlatformForceAuthMiddleware('/temp/hz-best-driver/2023', [
            {
                path: '/',
                component: () => import('@/views/temp/hz-best-driver/2023/home/index.vue'),
                children: [
                    {
                        path: 'candidate',
                        props: (route) => ({ ...route.query }),
                        component: () => import('@/views/temp/hz-best-driver/2023/candidate/index.vue'),
                    },
                ],
            },
        ]),
    ),
    addLoginMockMiddleware(
        '/',
        addMultiPlatformQuiteAuthMiddleware('/temp/hz-homecoming-trail/2024', [
            {
                path: '/',
                component: () => import('@/views/temp/hz-homecoming-trail/2024/home/index-loader.vue'),
            },
            {
                path: 'articles',
                component: () => import('@/views/temp/hz-homecoming-trail/2024/articles/index.vue'),
            },
            {
                path: 'hot-rank',
                component: () => import('@/views/temp/hz-homecoming-trail/2024/hot-rank/index.vue'),
            },
            {
                path: 'travel-treasure',
                component: () => import('@/views/temp/hz-homecoming-trail/2024/travel-treasure/index.vue'),
            },
            {
                path: 'city-detail/:cityCode',
                props: true,
                component: () => import('@/views/temp/hz-homecoming-trail/2024/city-detail/index.vue'),
            },
            {
                path: 'question/:articleId',
                props: true,
                component: () => import('@/views/temp/hz-homecoming-trail/2024/question/index.vue'),
            },
        ]),
    ),
    addLoginMockMiddleware(
        '/',
        addMultiPlatformQuiteAuthMiddleware('/ask-the-director', [
            {
                path: 'home',
                component: () => import('@/views/ask-the-director/HomePage/index.vue'),
            },
            {
                path: 'submit',
                props: (route) => ({ ...route.query }),
                component: () => import('@/views/ask-the-director/SubmitQuestion/index.vue'),
            },
            {
                path: 'question-list',
                props: (route) => ({ ...route.query }),
                component: () => import('@/views/ask-the-director/MyQuestions/list.vue'),
            },
            {
                path: 'question-detail',
                props: (route) => ({ ...route.query }),
                component: () => import('@/views/ask-the-director/MyQuestions/detail.vue'),
            },
            {
                path: 'result',
                props: (route) => ({ ...route.query }),
                component: () => import('@/views/ask-the-director/ResultPage/index.vue'),
            },
        ]),
    ),
    addRefreshFullpathMiddleware('/public-service', [
        {
            path: '',
            props: (route) => ({ ...route.query }),
            component: () => import('@/views/public-service/home/index.vue'),
        },
        {
            path: 'search',
            props: (route) => ({ ...route.query }),
            component: () => import('@/views/public-service/search/index.vue'),
        },
        {
            path: 'group/:groupId',
            props: true,
            component: () => import('@/views/public-service/group/index.vue'),
        },
    ]),
    {
        path: '/temp/doubleMeeting/2024/index',
        component: () => import('@/views/temp/doubleMeeting/2024/index.vue'),
    },
    {
        path: '/temp/doubleMeeting/china2024/index',
        component: () => import('@/views/temp/doubleMeeting/china2024/index.vue'),
    },
    addLoginMockMiddleware(
        '/',
        addMultiPlatformQuiteAuthMiddleware('/temp/hz-geological-museum/2024', [
            {
                path: '',
                component: () => import('@/views/temp/hz-geological-museum/2024/middleware/store-middleware.vue'),
                children: [
                    {
                        path: '',
                        component: () => import('@/views/temp/hz-geological-museum/2024/home/index.vue'),
                    },
                    {
                        path: 'stage',
                        component: () => import('@/views/temp/hz-geological-museum/2024/stage/index-loader.vue'),
                    },
                    {
                        path: 'rank',
                        component: () => import('@/views/temp/hz-geological-museum/2024/rank/index.vue'),
                    },
                ],
            },
        ]),
    ),

    addLoginMockMiddleware(
        '',
        addMultiPlatformQuiteAuthMiddleware('/temp/hz-womens-day/202403', {
            path: '',
            component: () => import('@/views/temp/hz-womens-day/202403/middleware/check-answering-status.vue'),
            children: [
                {
                    path: '',
                    component: () => import('@/views/temp/hz-womens-day/202403/home/index.vue'),
                },
                {
                    path: 'question',
                    component: () => import('@/views/temp/hz-womens-day/202403/question/index.vue'),
                },
                {
                    path: 'question/flow',
                    props: (route) => ({ ...route.query }),
                    component: () => import('@/views/temp/hz-womens-day/202403/question/flow/index.vue'),
                },
            ],
        }),
    ),

    addLoginMockMiddleware(
        '',
        addMultiPlatformQuiteAuthMiddleware('/temp/hz-315-disappointed-auto-show/2024', [
            {
                path: '',
                component: () => import('@/views/temp/hz-315-disappointed-auto-show/2024/end/index.vue'),
                children: [
                    {
                        path: 'candidate',
                        props: (route) => ({ ...route.query }),
                        component: () => import('@/views/temp/hz-315-disappointed-auto-show/2024/candidate/index.vue'),
                    },
                ],
            },
        ]),
    ),
    addLoginMockMiddleware(
        '',
        addMultiPlatformQuiteAuthMiddleware('/temp/national-theme-recitation', {
            path: '',
            component: () => import('@/views/temp/national-theme-recitation/home/index.vue'),
            children: [
                {
                    path: 'candidate',
                    component: () => import('@/views/temp/national-theme-recitation/candidate/index.vue'),
                    props: (route) => ({ ...route.query }),
                },
            ],
        }),
    ),
    addMultiPlatformQuiteAuthMiddleware('/temp/hz-315-realty-rights-advocate/2024', {
        path: '',
        component: () => import('@/views/temp/hz-315-realty-rights-advocate/2024/home/index.vue'),
    }),
    {
        path: '/temp/deep-reform-advocate',
        component: () => import('@/views/temp/deep-reform-advocate/home/index.vue'),
    },
    {
        path: '/study-tour/main-page-demo',
        component: () => import('@/views/study-tour/main-page-demo/home/index.vue'),
    },
    {
        path: '/study-tour/main-page-demo/module/:moduleKey',
        props: true,
        component: () => import('@/views/study-tour/main-page-demo/modules/index.vue'),
    },
    {
        path: '/study-tour/emcee',
        component: () => import('@/views/study-tour/emcee/home/index.vue'),
    },
    {
        path: '/study-tour/emcee/list',
        component: () => import('@/views/study-tour/emcee/list/index.vue'),
    },
    {
        path: '/study-tour/emcee/detail/:kidId',
        props: true,
        component: () => import('@/views/study-tour/emcee/detail/index.vue'),
    },
    addLoginMockMiddleware('/activity-rush/lucky-wheel',
        addMultiPlatformForceAuthMiddleware('', {
            path: '',
            props: (route) => ({ ...route.query }),
            component: () => import('@/views/activity-rush/lucky-wheel.vue'),
        }),
    ),
    addLoginMockMiddleware('/', [
        addMultiPlatformQuiteAuthMiddleware('/temp/cicaf/20th', [
            {
                path: 'enroll',
                component: () => import('@/views/temp/cicaf/20th/enroll/index.vue'),
            },
            {
                path: 'main',
                component: () => import('@/views/temp/cicaf/20th/main/home/index.vue'),
            },
            {
                path: 'main/question',
                component: () => import('@/views/temp/cicaf/20th/main/question/index-loader.vue'),
            },
            {
                path: 'voice-actor',
                component: () => import('@/views/temp/cicaf/20th/voice-actor/home/index.vue'),
            },
            {
                path: 'voice-actor/rule',
                component: () => import('@/views/temp/cicaf/20th/voice-actor/rule/index.vue'),
            },
            {
                path: 'voice-actor/appointment-make',
                component: () => import('@/views/temp/cicaf/20th/voice-actor/appointment-make/index-loader.vue'),
            },
        ]),
        addMultiPlatformForceAuthMiddleware('/temp/cicaf/20th', [
            {
                path: 'voice-actor/appointment-self',
                component: () => import('@/views/temp/cicaf/20th/voice-actor/appointment-self/index.vue'),
            },
            {
                path: 'voice-actor/appointment-details/:reserveId',
                props: true,
                component: () => import('@/views/temp/cicaf/20th/voice-actor/appointment-details/index.vue'),
            },
        ]),
    ]),
    addLoginMockMiddleware('/',
        addMultiPlatformQuiteAuthMiddleware('/temp/hzCityWalk/2024', [
            {
                path: 'home',
                component: () => import('@/views/temp/cityWalkActivitys/2024/index.vue'),
            },
            {
                path: 'rank',
                component: () => import('@/views/temp/cityWalkActivitys/2024/rank.vue'),
            },
            {
                path: 'mine',
                component: () => import('@/views/temp/cityWalkActivitys/2024/mine.vue'),
            },
            {
                path: 'publicize',
                component: () => import('@/views/temp/cityWalkActivitys/2024/publicizeSimple.vue'),
            },
            {
                path: 'publicizeNew',
                component: () => import('@/views/temp/cityWalkActivitys/2024/publicize.vue'),
            },
            {
                path: 'redirect',
                component: () => import('@/views/temp/cityWalkActivitys/2024/redirect.vue'),
            },
        ]),
    ),
    addLoginMockMiddleware('/',
        addMultiPlatformQuiteAuthMiddleware('/temp/national-caring-day', [
            {
                path: '',
                component: () => import('@/views/temp/national-caring-day/home/index.vue'),
            },
            {
                path: 'shop',
                component: () => import('@/views/temp/national-caring-day/shop/index.vue'),
            },
            {
                path: 'wish-self',
                component: () => import('@/views/temp/national-caring-day/wish-self/index.vue'),
            },
            {
                path: 'wish-claim',
                component: () => import('@/views/temp/national-caring-day/wish-claim/index-loader.vue'),
            },
            {
                path: 'video-live',
                component: () => import('@/views/temp/national-caring-day/video-live/index.vue'),
            },
        ]),
    ),
    addLoginMockMiddleware('/',
        [
            addMultiPlatformQuiteAuthMiddleware('/temp/hz-exam-assistance/2024', [
                {
                    path: '',
                    component: () => import('@/views/temp/hz-exam-assistance/2024/home/index.vue'),
                },
                {
                    path: 'challenge',
                    component: () => import('@/views/temp/hz-exam-assistance/2024/challenge/home/index.vue'),
                },
                {
                    path: 'challenge/rank',
                    props: true,
                    component: () => import('@/views/temp/hz-exam-assistance/2024/challenge/rank/index.vue'),
                },
            ]),
            addMultiPlatformForceAuthMiddleware('/temp/hz-exam-assistance/2024', [
                {
                    path: 'challenge/question/:type',
                    props: true,
                    component: () => import('@/views/temp/hz-exam-assistance/2024/challenge/question/index.vue'),
                },
            ]),
        ],
    ),
    addLoginMockMiddleware('/',
        addMultiPlatformQuiteAuthMiddleware('/temp/cicaf/20th/classical-chic', [
            {
                path: 'home',
                component: () => import('@/views/temp/cicaf/20th/classical-chic/home.vue'),
            },
            {
                path: 'create',
                component: () => import('@/views/temp/cicaf/20th/classical-chic/create.vue'),
            },
            {
                path: 'result',
                component: () => import('@/views/temp/cicaf/20th/classical-chic/result.vue'),
            },
            {
                path: 'mine',
                component: () => import('@/views/temp/cicaf/20th/classical-chic/mine.vue'),
            },
        ]),
    ),
    addLoginMockMiddleware('',
        addMultiPlatformQuiteAuthMiddleware('/temp/hz-home-dco-challenge/2024', [
            {
                path: '',
                component: () => import('@/views/temp/hz-home-dco-challenge/2024/home/index.vue'),
            },
            {
                path: 'shop',
                component: () => import('@/views/temp/hz-home-dco-challenge/2024/shop/index.vue'),
            },
        ]),
    ),
    addLoginMockMiddleware('',
        addMultiPlatformForceAuthMiddleware('/temp/hz-exquisite-office-env/2024',
            addOnlyInUserRosterMiddleware({
                path: '/',
                instanceKey: 'hcrt_happy_2023',
                coverImage: 'https://static.kaiba315.com.cn/0lxaazw970o6zech27vr.png',
            }, {
                path: '',
                component: () => import('@/views/temp/hz-exquisite-office-env/2024/home/index.vue'),
                children: [
                    {
                        path: 'candidate/:candidateId',
                        props: true,
                        component: () => import('@/views/temp/hz-exquisite-office-env/2024/candidate/index.vue'),
                    },
                ],
            }),
        ),
    ),
    addMultiPlatformForceAuthMiddleware(
        '/legacyact/activity',
        addNddynyV2Middleware('/', [
            {
                path: 'list',
                component: () => import('@/views/legacyact/activity/list'),
            },
            {
                path: 'info',
                props: (route) => ({ ...route.query }),
                component: () => import('@/views/legacyact/activity/info'),
            },
        ]),
    ),
    addLoginMockMiddleware('/',
        addMultiPlatformQuiteAuthMiddleware('/temp/circle-like-rank', [
            {
                path: 'rank',
                component: () => import('@/views/temp/circleLikeRank/rank.vue'),
            },
        ]),
    ),
    {
        path: '/temp/special-subjects/hz/river-future/index',
        component: () => import('@/views/temp/specialSubjects/hz/riverFuture/index.vue'),
    },
    addLoginMockMiddleware('',
        [
            addMultiPlatformQuiteAuthMiddleware('/temp/hz-pediatric-prowess-contest/2024', [
                {
                    path: '',
                    component: () => import('@/views/temp/hz-pediatric-prowess-contest/2024/home/index.vue'),
                },
                {
                    path: 'contestant',
                    component: () => import('@/views/temp/hz-pediatric-prowess-contest/2024/contestant/index.vue'),
                },
                {
                    path: 'challenge',
                    component: () => import('@/views/temp/hz-pediatric-prowess-contest/2024/challenge/home/index.vue'),
                },
                {
                    path: 'challenge/rank',
                    component: () => import('@/views/temp/hz-pediatric-prowess-contest/2024/challenge/rank/index.vue'),
                },
                {
                    path: 'finals',
                    component: () => import('@/views/temp/hz-pediatric-prowess-contest/2024/finals/index.vue'),
                },
            ]),
            addMultiPlatformForceAuthMiddleware('/temp/hz-pediatric-prowess-contest/2024', [
                {
                    path: 'challenge/start',
                    component: () => import('@/views/temp/hz-pediatric-prowess-contest/2024/challenge/start/index.vue'),
                },
            ]),
        ],
    ),
    {
        path: '/temp/policy-topic/common/index',
        component: () => import('@/views/temp/specialSubjects/template/index.vue'),
    },
    addLoginMockMiddleware('/',
        addMultiPlatformQuiteAuthMiddleware('/temp/hz/aichiaiwan/praise-rank', [
            {
                path: 'home',
                component: () => import('@/views/temp/rankProjects/praise/rank.vue'),
            },
        ]),
    ),
]

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
})

export default router
